var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
var Checkbox = forwardRef(function (_a, ref) {
    var id = _a.id, label = _a.label, labelClass = _a.labelClass, inputClass = _a.inputClass, _b = _a.required, required = _b === void 0 ? false : _b, props = __rest(_a, ["id", "label", "labelClass", "inputClass", "required"]);
    return (_jsxs(_Fragment, { children: [_jsx("input", __assign({ ref: ref, id: id, type: 'checkbox', required: required, className: inputClass }, props)), label && (_jsx("label", { className: labelClass, htmlFor: id, children: label }))] }));
});
// Display name for debugging purposes
Checkbox.displayName = 'Checkbox';
export default Checkbox;
